export * from '../clube/list/clubeList.component';
export * from '../clube/create/clubeCreate.component';
export * from '../clube/edit/clubeEdit.component';
export * from '../clube/detail/clubeDetail.component';
export * from '../clube/search/clubeSearch.component';